export default __webpack_public_path__ + "Planet_Search.7a86b53e.svg";